import axios_instance from './axios_instance.js'
import common from '@/api/common.js'
import role from "@/api/role.js";
import account from "@/api/account.js";
import productCategorys from "@/api/product-categorys.js";
import tenants from "@/api/tenants.js";
import user from "@/api/user.js";
import templates from "@/api/templates.js";
import orders from "@/api/orders.js";
import systemSettings from "@/api/system-settings.js";

export default {
    // 公用模块
    common: {
        tags: () =>
            axios_instance.config(common.tags).request(),
        productCategories: params =>
            axios_instance.config(common.productCategories).request({
                params: params
            }),
        tagTypes: () =>
            axios_instance.config(common.tagTypes).request(),        
        serviceTypes: id =>
            axios_instance.config(common.serviceTypes, {
                id: id
            }).request(),
        areas: () =>
            axios_instance.config(common.areas).request(),      
        uploadFilesMultiple: data =>
            axios_instance.config(common.uploadFilesMultiple).request({
                data: data
            }),    
    },
    // 用户模块
    user: {
        list: params =>
            axios_instance.config(user.list).request({
                params: params
            }),
        login: data =>
            axios_instance.config(user.login).request({
                data: data
            }),
        menus: () => 
            axios_instance.config(user.menus).request(),
        operatorsMenus: id =>
            axios_instance.config(user.operatorsMenus, {
                id: id
            }).request(), 
    },
    // 账号模块
    account: {
        list: params =>
            axios_instance.config(account.list).request({
                params: params
            }),
        detail: id =>
            axios_instance.config(account.detail, {
                id: id
            }).request(),
        add: data =>
            axios_instance.config(account.add).request({
                data: data
            }),
        edit: (id, data) =>
            axios_instance.config(account.edit, {
                id: id
            }).request({
                data: data
            }),
        delete: id =>
            axios_instance.config(account.delete, {
                id: id
            }).request()     
    },
    // 角色模块
    role: {
        list: params =>
            axios_instance.config(role.list).request({
                params: params
            }),
        detail: id =>
            axios_instance.config(role.detail, {
                id: id
            }).request(),
        add: data =>
            axios_instance.config(role.add).request({
                data: data
            }),
        edit: (id, data) =>
            axios_instance.config(role.edit, {
                id: id
            }).request({
                data: data
            }),
        delete: id =>
            axios_instance.config(role.delete, {
                id: id
            }).request(),
        menu: id => axios_instance.config(role.menu, {
                id: id
            }).request(),
        setMenu: (id, data) =>
            axios_instance.config(role.setMenu, {
                id: id
            }).request({
                data: data
            }),
    },
    // 产品分类模块
    productCategorys: {
        list: params =>
            axios_instance.config(productCategorys.list).request({
                params: params
            }),  
        add: data =>
            axios_instance.config(productCategorys.add).request({
                data: data
            }),
        edit: (id, data) =>
            axios_instance.config(productCategorys.edit, {
                id: id
            }).request({
                data: data
            }), 
        detail: id =>
            axios_instance.config(productCategorys.detail, {
                id: id
            }).request(),     
        operators: params =>
            axios_instance.config(productCategorys.operators).request({
                params: params
            }),
        serviceItemsList: (id, params) =>
            axios_instance.config(productCategorys.serviceItemsList, {
                id: id
            }).request({
                params: params
            }),  
        addServiceItems: (id, data) =>
            axios_instance.config(productCategorys.addServiceItems, {
                id: id
            }).request({
                data: data
            }),
        editServiceItems: (id, sid, data) =>
            axios_instance.config(productCategorys.editServiceItems, {
                id: id,
                sid: sid
            }).request({
                data: data
            }), 
        serviceItemsDetail: (id, sid) =>
            axios_instance.config(productCategorys.serviceItemsDetail, {
                id: id,
                sid: sid
            }).request(),
        specsList: (id, params) =>
            axios_instance.config(productCategorys.specsList, {
                id: id
            }).request({
                params: params
            }),  
        addSpecs: (id, data) =>
            axios_instance.config(productCategorys.addSpecs, {
                id: id
            }).request({
                data: data
            }),
        editSpecs: (id, sid, data) =>
            axios_instance.config(productCategorys.editSpecs, {
                id: id,
                sid: sid
            }).request({
                data: data
            }), 
        specsDetail: (id, sid) =>
            axios_instance.config(productCategorys.specsDetail, {
                id: id,
                sid: sid
            }).request(), 
        productsDetail: params =>
            axios_instance.config(productCategorys.productsDetail).request({
                params: params
            }),
        editProducts: data =>
            axios_instance.config(productCategorys.editProducts).request({
                data: data
            }),
        pricesList: id =>
            axios_instance.config(productCategorys.pricesList, {
                id: id
            }).request(),        
        editPrices: (id, data) =>
            axios_instance.config(productCategorys.editPrices, {
                id: id
            }).request({
                data: data
            }),    
    },
    // 商户模块
    tenants: {
        list: params =>
            axios_instance.config(tenants.list).request({
                params: params
            }),
        quickSearchList: params =>
            axios_instance.config(tenants.quickSearchList).request({
                params: params
            }),
        add: data =>
            axios_instance.config(tenants.add).request({
                data: data
            }),
        edit: (id, data) =>
            axios_instance.config(tenants.edit, {
                id: id
            }).request({
                data: data
            }), 
        detail: id =>
            axios_instance.config(tenants.detail, {
                id: id
            }).request(),
        antList: params =>
            axios_instance.config(tenants.antList).request({
                params: params
            }),
        antEdit: (id, data) =>
            axios_instance.config(tenants.antEdit, {
                id: id
            }).request({
                data: data
            }),
        antTenantList: id =>
            axios_instance.config(tenants.antTenantList, {
                id: id
            }).request(),
        zftProgressSearch: id =>
            axios_instance.config(tenants.zftProgressSearch, {
                id: id
            }).request(),
        zftProgress: id =>
            axios_instance.config(tenants.zftProgress, {
                id: id
            }).request(),
        addTradeSplit: id =>
            axios_instance.config(tenants.addTradeSplit, {
                id: id
            }).request(),
        productCategoriesList: id =>
            axios_instance.config(tenants.productCategoriesList, {
                id: id
            }).request(),
        productCategories: id =>
            axios_instance.config(tenants.productCategories, {
                id: id
            }).request(),
        batchProductCategories: (id, data) =>
            axios_instance.config(tenants.batchProductCategories, {
                id: id
            }).request({
                data: data
            }),
        tradeSplitList: (id, params) =>
            axios_instance.config(tenants.tradeSplitList, {
                id: id
            }).request({
                params: params
            }),
        editTradeSplit: (id, data) =>
            axios_instance.config(tenants.editTradeSplit, {
                id: id
            }).request({
                data: data
            }),    
    },
    // 模板模块
    templates: {
        list: params =>
            axios_instance.config(templates.list).request({
                params: params
            }),  
        statistics: id =>
            axios_instance.config(templates.statistics, {
                id: id
            }).request(),
        releasesList: (id, params) =>
            axios_instance.config(templates.releasesList, {
                id: id
            }).request({
                params: params
            }),
        addReleases: (id, data) =>
            axios_instance.config(templates.addReleases, {
                id: id
            }).request({
                data: data
            }),
        editReleases: (id, data) =>
            axios_instance.config(templates.editReleases, {
                id: id
            }).request({
                data: data
            }),   
        detail: (id, params) =>
            axios_instance.config(templates.detail, {
                id: id
            }).request({
                params: params
            }), 
        auditApply: (id, data) =>
            axios_instance.config(templates.auditApply, {
                id: id
            }).request({
                data: data
            }),
    },
    // 订单模块
    orders: {
        filtersList: () =>
            axios_instance.config(orders.filtersList).request(),
        list: params =>
            axios_instance.config(orders.list).request({
                params: params
            }),
        detail: id =>
            axios_instance.config(orders.detail, {
                id: id
            }).request(), 
        edit: (id, data) =>
            axios_instance.config(orders.edit, {
                id: id
            }).request({
                data: data
            }),
        workOrders: id =>
            axios_instance.config(orders.workOrders, {
                id: id
            }).request(), 
        workOrdersSync: id =>
            axios_instance.config(orders.workOrdersSync, {
                id: id
            }).request(), 
        tradeSplitRecords: params =>
            axios_instance.config(orders.tradeSplitRecords).request({
                params: params
            }),    
        // TODO: 新增
        tradeSplitRe: id =>
            axios_instance.config(orders.tradeSplitRe, {
                id: id
            }).request(),               
    },
    // 系统设置模块
    systemSettings: {
        antMiniInfo: () => axios_instance.config(systemSettings.antMiniInfo).request(),
        editAntMiniInfo: data =>
            axios_instance.config(systemSettings.editAntMiniInfo).request({
                data: data
            }),
        tradeSplit: params => 
            axios_instance.config(systemSettings.tradeSplit).request({
                params: params
            }),
        editTradeSplit: data =>
            axios_instance.config(systemSettings.editTradeSplit).request({
                data: data
            })    
    }
};



// WEBPACK FOOTER //
// ./src/models/request.js